// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'businessCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      // disabled: !ctx.isCreate,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      disabled: ctx.query?.businessCompanyNo == '',
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
    },
    {
      prop: 'expenseType',
      name: '费用类型',
      type: 'select',
      options: ctx.expenseTypeList,
    },
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
    {
      name: '应付账期',
      prop: 'accountPeriod',
      type: 'date',
      format: 'yyyy-MM',
    },
    {
      // 申请日期从
      name: '业务结算日期从',
      prop: 'periodDateFrom',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '业务结算日期至',
      prop: 'periodDateUntil',
      type: 'endDaterangePicker',
    },
    {
      name: '客户名称',
      prop: 'customerName',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.query.businessCompanyNo,
        departmentCode: ctx.query.businessDepartmentCode,
        partnerTypes: 'HZHB01',
      },
      isMultiple: true,
      changeMethod: ctx.changeCustomsMethod,
      currentValue: ctx.query?.customerName,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'propertyLeaseContract',
      extraData: {
        contractCompanyNo: ctx.query.businessCompanyNo,
        contractDepartmentNo: ctx.query.businessDepartmentCode,
      },
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
    },
    {
      prop: 'createMethod',
      name: '创建方式',
      type: 'select',
      options: ctx.dictListMap?.createMethod || [],
    },
    {
      name: '原币结算金额(含税)',
      prop: ['originalTotalAmountStart', 'originalTotalAmountEnd'],
      type: 'inputRange',
      precision: 2, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
    },
    {
      name: '结算单编号',
      prop: 'settlementNoLike',
      type: 'input',
    },
    {
      prop: 'salesmanNo',
      name: '业务员',
      type: 'searchTableSpec',
      searchType: 'personnel',
      extraData: {
        personCompanyCode: ctx.query.businessCompanyNo,
        personDepartmentCode: ctx.query.businessDepartmentCode,
      },
      isMultiple: true,
      changeMethod: ctx.changeSalesmanNoMethod,
    },
    {
      //
      name: '费用生成日期从',
      prop: 'expenseGenerationDateStart',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '费用生成日期至',
      prop: 'expenseGenerationDateEnd',
      type: 'endDaterangePicker',
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },

  {
    field: 'expenseNo',
    title: '费用编号',
    visible: true,
  },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
    visible: true,
  },
  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
  {
    field: 'businessCategory',
    title: '业务类别',
    visible: true,
  },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
    width: '150',
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'accountPeriod',
    title: '应付账期',
    visible: true,
    width: '150',
  },

  {
    field: 'expenseType',
    title: '费用类型',
    visible: true,
  },
  {
    field: 'originalPrice',
    title: '结算单价(含税)',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unit',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },

  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },
  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
    visible: true,
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
    visible: true,
  },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'businessDocCode',
    title: '业务单据编码',
    visible: true,
  },

  {
    field: 'spaceAssetName',
    title: '空间资产',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '结算单编号',
    visible: true,
  },

  {
    field: 'salesmanName',
    title: '业务员',
    visible: true,
  },
];

// 默认显示的按钮
export const defaultMenuBtnList = [
  {
    id: 1,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },

  {
    id: 2,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];

import BASE_API from '@/api/dataBase';
export default {
  data() {
    return {
      companyList: [],
      departmentList: [],
      expenseTypeList: [],
    };
  },
  methods: {
    // 修改客户
    changeCustomsMethod(val) {
      const rowData = val[0];
      this.query = {
        ...this.query,
        customerName: rowData?.partnerZhName,
        customerCode: rowData?.partnerCode,
      };
    },
    // 获取公司
    async _getCompanyApi() {
      // console.log('开始获取公司', this.userInfo);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        this.companyList = data.data?.personCompanyInfo;
        if (!this.userInfo.companyCode) {
          const companyCode = data.data.personCompanyInfo
            ? data.data.personCompanyInfo[0].companyCode
            : null;
          const companyName = data.data.personCompanyInfo
            ? data.data.personCompanyInfo[0].companyName
            : null;
          this.query = {
            ...this.query,
            businessCompanyNo: companyCode,
            businessCompanyName: companyName,
          };
        } else {
          this.query = {
            ...this.query,
            businessCompanyNo: this.userInfo.companyCode,
            businessCompanyName: this.userInfo.companyName,
          };
        }

        this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        this.departmentList = data.data?.personDepartmentInfo;
        if (isFirst) {
          this.query = {
            ...this.query,
            businessDepartmentCode: this.userInfo?.departmentCode,
            businessDepartmentName: this.userInfo?.departmentName,
          };
          setTimeout(() => {
            this.getTableData();
          }, 10);
        }
      } else {
        console.error('获取部门失败');
      }
    },
    // 切换公司
    changeCompanyHandler(val) {
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      this.query = {
        ...this.query,
        businessDepartmentCode: '',
        businessDepartmentName: '',
        businessCompanyNo: val,
        businessCompanyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.query = {
        ...this.query,
        businessDepartmentCode: val,
        businessDepartmentName: item.personDepartmentName,
      };
    },
  },

  mounted() {
    this.$nextTick(() => {
      this._getCompanyApi();
    });
    this.expenseTypeList = [{ value: '01', label: '押金' }];
  },
};
